import React from 'react';
import { DataExplorerMetricCards } from './DataExplorerMetricCards';
import { DataExplorerDimensionBarChart } from './DataExplorerDimensionBarChart';
import { DataExplorerPieChart } from './DataExplorerPieChart';

/**
 * Wrapper que agrupa los nuevos gráficos del Data Explorer (debajo de la tabla).
 * Solo se renderiza cuando hay datos.
 *
 * Props:
 *  - results: { tableData, ... }
 *  - lastFilters: { dimensions, metrics, compare, ... }
 *  - fieldsData: { FIELD_DATA_BY_ID, ... }
 *  - chartPrefs: preferencias de visualización explícitas (opcional). Si viene, gana sobre
 *    LocalStorage y los widgets tampoco persisten ahí. Lo usa el portal del cliente, donde
 *    las prefs son las que guardó la agencia en la vista, no las del navegador de quien mira.
 */
export function DataExplorerChartsSection({ results, lastFilters, fieldsData, chartPrefs = null, onChartPrefsChange, viewMode = 'agency' }) {
    const hasData = results && results.tableData && results.tableData.rows && results.tableData.rows.length > 0;
    if (!hasData || !lastFilters) return null;

    return (
        <div className="de-charts-section">
            {/* 1. Métricas clave */}
            <DataExplorerMetricCards
                results={results}
                lastFilters={lastFilters}
                fieldsData={fieldsData}
                chartPrefs={chartPrefs}
                onChartPrefsChange={onChartPrefsChange}
                viewMode={viewMode}
            />
            {/* 2. Gráfico de barras (8 cols) + torta (4 cols) en una misma fila */}
            <div className="row de-charts-row">
                <div className="col-8">
                    <DataExplorerDimensionBarChart
                        results={results}
                        lastFilters={lastFilters}
                        fieldsData={fieldsData}
                        chartPrefs={chartPrefs}
                        onChartPrefsChange={onChartPrefsChange}
                    />
                </div>
                <div className="col-4">
                    <DataExplorerPieChart
                        results={results}
                        lastFilters={lastFilters}
                        fieldsData={fieldsData}
                        chartPrefs={chartPrefs}
                        onChartPrefsChange={onChartPrefsChange}
                    />
                </div>
            </div>
        </div>
    );
}
